<template>
  <button
    class="btn"
    :class="[{ 'btn-loading': props.isSubmitted }, props.buttonClass]"
    v-bind="attrs"
    type="submit"
    :disabled="props.disabled"
  >
    <LoadingSpinner v-if="props.isSubmitted" size="25px" />
    <slot v-else />
  </button>
</template>

<script lang="ts" setup>
import { defineProps, useAttrs } from "vue";
import LoadingSpinner from "./loading-spinner.vue";

const props = defineProps<{
  isSubmitted: boolean;
  buttonClass: string;
  useRecaptcha: boolean;
  disabled: boolean;
}>();

const attrs = useAttrs();
</script>
